module.exports = __webpack_public_path__ + "static/media/Illus-Empty_1.d93dbcbb.png";